<template>
    <div class="date-card">
        <div class="calendar-container">
            <date-range-picker
                ref="picker"
                v-model="dateRange"
                opens="left"
                :locale-data="locale"
                :time-picker="true"
                :ranges="false"
                :time-picker24-hour="true"
                :show-week-numbers="false"
                :show-dropdowns="false"
                :auto-apply="true"
                :linked-calendars="true"
                @update="save"
            >
                <template #input="picker" style="min-width: 350px">
                    <div class="date-container">
                        <div class="small-date">
                            <div v-if="dateTime.smallDate.day" class="large-title-regular">
                                {{ picker.startDate | smallDateDay }}
                            </div>
                            <div v-if="dateTime.smallDate.month" class="label">
                                {{ picker.startDate | smallDateMonth }}
                            </div>
                        </div>
                        <div class="large-date">
                            <p v-if="dateTime.largeDate" class="copy-m">
                                {{ $t('general.from') }}
                                <span class="bold">{{ picker.startDate | largeDate }}</span>
                            </p>
                            <p v-if="dateTime.largeTime" class="copy-m">
                                {{ $t('general.to') }}
                                <span class="bold">{{ picker.endDate | largeDate }}</span>
                            </p>
                        </div>
                    </div>
                </template>
            </date-range-picker>
            <!--<FeatherIcon class="edit-date" name="edit" @click="openModal"></FeatherIcon>-->
        </div>
    </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
    name: 'DateCard',
    components: {
        DateRangePicker,
    },
    filters: {
        largeDate(val) {
            let locale = 'de-DE'
            if (val) {
                let largeTimeEnd = val.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
                return (
                    val.toLocaleDateString(locale, {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                    }) +
                    ',  ' +
                    largeTimeEnd
                )
            } else {
                return ''
            }
        },
        smallDateDay(val) {
            let locale = 'de-DE'
            return val ? val.toLocaleDateString(locale, { day: 'numeric' }) : ''
        },
        smallDateMonth(val) {
            let locale = 'de-DE'
            return val ? val.toLocaleDateString(locale, { month: 'short' }) : ''
        },
    },
    props: {
        value: {
            type: Object,
            default: () => {
                return { startDate: null, endDate: null }
            },
        },
    },
    data() {
        return {
            modalOpen: false,
            dateRange: {
                startDate: null,
                endDate: null,
            },
            locale: {
                direction: 'ltr',
                format: 'DD-MM-YYYY HH:mm:ss',
                separator: ' - ',
                applyLabel: 'Fertig',
                cancelLabel: 'Abbrechen',
                weekLabel: 'W',
                customRangeLabel: 'Custom Range',
                daysOfWeek: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                monthNames: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
                firstDay: 0,
            },
        }
    },
    computed: {
        dateTime() {
            if (!this.value || !this.value.startDate)
                return {
                    smallDate: {
                        day: null,
                        month: null,
                    },
                    largeDate: null,
                    largeTime: null,
                }

            let startTime = new Date(this.value.startDate)
            let endTime = new Date(this.value.endDate)
            let locale = 'de-DE'

            let largeTime =
                startTime.toLocaleTimeString(locale, {
                    hour: '2-digit',
                    minute: '2-digit',
                }) +
                ' - ' +
                endTime.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
            let largeTimeStart = startTime.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
            let largeTimeEnd = endTime.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })

            return {
                smallDate: {
                    day: startTime.toLocaleDateString(locale, { day: 'numeric' }),
                    month: startTime.toLocaleDateString(locale, { month: 'short' }),
                },
                largeDate:
                    startTime.toLocaleDateString(locale, {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                    }) +
                    ', ' +
                    startTime.toLocaleDateString(locale, { weekday: 'long' }),
                largeTime: largeTime,
                startDateTime:
                    startTime.toLocaleDateString(locale, {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                    }) +
                    ',  ' +
                    largeTimeStart,
                endDateTime:
                    endTime.toLocaleDateString(locale, {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                    }) +
                    ',  ' +
                    largeTimeEnd,
            }
        },
        dateMin() {
            if (this.dateRange) {
                return this.toLocalISOString(this.dateRange.startDate)
            }

            return new Date().toISOString().substring(0, 16)
        },
    },
    watch: {
        value: {
            deep: true,
            handler: function (newVal) {
                this.dateRange = newVal
            },
        },
    },
    mounted() {
        this.dateRange = this.value
    },
    methods: {
        openModal() {
            this.modalOpen = true
        },
        save() {
            let dateRange = {
                startDate: new Date(this.dateRange.startDate),
                endDate: new Date(this.dateRange.endDate),
            }

            if (dateRange.startDate instanceof Date && dateRange.endDate instanceof Date) {
                this.$emit('input', dateRange)

                this.modalOpen = false
            }
        },
        toLocalISOString(dateString) {
            let d = new Date(dateString)
            let pad = function (n) {
                return n < 10 ? '0' + n : n
            }
            let tz = d.getTimezoneOffset() // mins
            let tzs = `${tz > 0 ? '-' : '+'}${pad(parseInt(Math.abs(tz / 60)))}`

            if (tz % 60 !== 0) tzs += pad(Math.abs(tz % 60))

            if (tz === 0)
                // Zulu time == UTC
                tzs = 'Z'

            return (
                d.getFullYear() +
                '-' +
                pad(d.getMonth() + 1) +
                '-' +
                pad(d.getDate()) +
                'T' +
                pad(d.getHours()) +
                ':' +
                pad(d.getMinutes()) +
                ':' +
                pad(d.getSeconds()) +
                tzs
            )
        },
    },
}
</script>

<style scoped lang="sass">
.date-card
    .edit-date
        cursor: pointer

    .modal
        .headline-container
            padding: $m $m 0 $m

        .modal-main-content
            padding: $m

            .input-group
                margin-bottom: $l

            .input + .input
                margin-top: $s

    .calendar-container
        background: $neutral-white
        box-shadow: $box-mois
        display: flex
        justify-content: space-between
        border-radius: 10px
        align-items: center
        margin-bottom: $l

        .vue-daterange-picker
            width: 100%
            box-sizing: border-box
            &::v-deep
                .reportrange-text
                    padding: $s $l $s $s
                    background: none
                    box-sizing: border-box
                    border: none

                .daterangepicker
                    min-width: auto
                    &.opensleft
                        right: 0
                        margin-top: 0
                        border: none
                            radius: 10px
                        padding: $s $m
                        box-shadow: $precise

                        &:before, &:after
                            display: none
                    .calendars
                        .calendars-container
                            .drp-calendar + .drp-calendar
                                margin-left: $l

                            .drp-calendar
                                padding: 0
                                width: auto
                                min-width: auto

                                &:nth-child(1)
                                    .calendar-time
                                        &:before
                                            content: 'Start time'

                                &:nth-child(2)
                                    .calendar-time
                                        &:before
                                            content: 'End time'


                                .calendar-time
                                    display: flex
                                    align-items: center
                                    background: $gray-2
                                    border-radius: 8px
                                    padding: $s $m
                                    @extend %copy-s
                                    @extend %bold

                                    &:before
                                        flex: 1
                                        text-align: left
                                    select
                                        width: 50px
                                        background: white
                                        border: none
                                            radius: 5px
                                        height: 36px
                                        @extend %copy-s
                                        @extend %bold

                                        &:nth-child(1)
                                            margin-right: 2px
                                        &:nth-child(2)
                                            margin-left: 2px



                                .calendar-table
                                    padding: 0

                                    table
                                        border-collapse: collapse
                                        border-spacing: 0
                                        thead
                                            tr
                                                height: 30px
                                                display: flex
                                                th
                                                    min-width: 30px
                                                    width: 30px
                                                    min-height: 30px
                                                    height: 30px
                                                    padding: 0
                                                    border: none
                                                    &.month
                                                        @extend %copy-m
                                                        @extend %bold
                                                        flex: 1
                                        tbody
                                            tr
                                                height: 30px
                                                display: flex
                                                th
                                                    @extend %label
                                                td, th
                                                    @extend %copy-s
                                                    @extend %bold
                                                    color: $neutral-black
                                                    min-width: 30px
                                                    width: 30px
                                                    min-height: 30px
                                                    height: 30px
                                                    padding: 0
                                                    border: none
                                                    overflow: hidden
                                                    display: flex
                                                    white-space: nowrap
                                                    align-items: center
                                                    justify-content: center

                                                    &.in-range
                                                        background: $neutral-1

                                                    &.off
                                                        background: none
                                                        color: $neutral-2


                                                    &.active
                                                        color: $neutral-white
                                                        position: relative
                                                        overflow: visible
                                                        z-index: 1
                                                        background: none

                                                        &::after
                                                            content: ''
                                                            position: absolute
                                                            background: $primary-2
                                                            width: 100%
                                                            height: 100%
                                                            z-index: -1
                                                            border-radius: 99em

                                                        &::before
                                                            content: ''
                                                            background: $neutral-1
                                                            width: 50%
                                                            height: 100%
                                                            position: absolute
                                                            z-index: -1

                                                        &.start-date
                                                            &::before
                                                                right: 0
                                                        &.end-date
                                                            &::before
                                                                left: 0

                                                        &.start-date.end-date
                                                            &::before
                                                                display: none





        .date-container
            display: flex
            align-items: center

        .small-date
            width: 64px
            height: 64px
            display: flex
            align-items: center
            flex-direction: column
            justify-content: center
            margin-right: $m

            .label
                color: $red

        .large-date
            p:first-child
                margin-bottom: $xxs

        .feather-icon
            width: 2em
            height: 2em
            color: $neutral-2
</style>
